import { IWidgetElement } from '../loyalty-widget-components';

export interface ILoyaltyDashboardViewProps {
  /** Array of widgets to populate dashboard view */
  widgets: Array<IWidgetElement>;
  /** Dismisses loyalty dashboard */
  handleDismiss(): void;
}

export enum LoyaltyDashboardWidgets {
  DoubleButton = 'doubleButtonWidget',
  Greeting = 'greetingWidget',
  History = 'historyWidget',
  Links = 'linkWidget',
  MarketingTiles = 'marketingTileGroupWidget',
  PointsMeter = 'pointsMeterWidget',
  Reward = 'pointsAndRewardsWidget',
  Tiers = 'tiersWidget',
  Notifications = 'notificationsWidget',
  Quests = 'questsWidget',
}
